"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _lib = require("../../lib");
var _drawerModule = _interopRequireDefault(require("./drawer.module.scss"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ArcDrawer(props) {
  return /*#__PURE__*/_react["default"].createElement(_lib.Drawer, _extends({}, props, {
    title: props.title,
    placement: props.placement,
    className: props.className ? 'drawerWrapper' : '',
    closable: props.closable,
    onClose: props.onClose,
    open: props.visible,
    height: props.height,
    width: props.width,
    getContainer: props.getContainer,
    style: props.mobile,
    footer: props.footer ? props.footer : false
  }), props.children);
}
var _default = ArcDrawer;
exports["default"] = _default;